import { render, staticRenderFns } from "./AddFromCart.vue?vue&type=template&id=67a4d9bd"
import script from "./AddFromCart.vue?vue&type=script&lang=js"
export * from "./AddFromCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports